import { useState } from 'react';
import { Card, TextField, CardContent, CardHeader, Stack, Button } from '@mui/material';

export interface NoteProps {
	val: string | undefined;
	title: string;
	onSave: (note: string) => void;
}

export const Note = ({ val, title, onSave }: NoteProps) => {
	const [noteValue, setNoteValue] = useState(val ?? '');
	// const [isEditing, setIsEditing] = useState(false);

	const onNoteChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setNoteValue(e.target.value);
	};

	const onSaveNote = () => {
		onSave(noteValue);
	};

	return (
		<Card variant="outlined">
			<CardHeader title={title} sx={{ color: 'grey.600' }} />
			<CardContent>
				<TextField
					fullWidth
					multiline
					value={noteValue}
					rows={4}
					onChange={onNoteChange}
					inputProps={{ maxLength: 1000 }}
					// disabled={!isEditing || isLoading}
					placeholder={`Enter ${title.toLowerCase()}...`}
					variant="outlined"
					// sx={{
					// 	'& .MuiInputBase-root': {
					// 		backgroundColor: isEditing ? 'background.paper' : 'action.hover',
					// 	},
					// }}
				/>
				<Stack direction="row" spacing={2} sx={{ mt: 2 }}>
					<Button variant="contained" onClick={onSaveNote}>
						Save
					</Button>
				</Stack>
			</CardContent>
		</Card>
	);
};
